export const ModalChangeEmailTranslationsEn = {
  changeEmailMessage:
    'A confirmation email for the change of email has been sent to {{email}}. Please check your mailbox and follow the instructions to confirm.',
  changeEmailTitle: 'Change Email',
  enterEmailLabel: 'Enter your email address',
  emailPlaceholder: 'example@gmail.com',
  'Email in use': 'Oops, this email is already taken!',
  saveButton: 'Save',
};
